import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent {
  @ViewChild('audioElement') audioElement!: ElementRef<HTMLAudioElement>;
  @Input() url!: string;
  isPlaying = false;
  currentTime = 0;
  duration = 0;
  isHover = false;
  constructor(private commonservice: CommonService) { }

  togglePlay() {
    const audio = this.audioElement.nativeElement;
    if (this.isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  playAudio() {
    const audio = this.audioElement.nativeElement;
    if (!this.isPlaying) {
      if (!audio.src) {
        this.url = this.commonservice.get_storage_cdn_url(this.url);
        audio.src = this.url;
        audio.load();
      }
      audio.play();
      this.isPlaying = true;
    } else {
      audio.pause();
      this.isPlaying = false;
    }
  }

  ngAfterViewInit() {
    const audio = this.audioElement.nativeElement;
    audio.addEventListener('timeupdate', () => {
      this.currentTime = audio.currentTime;
      this.duration = audio.duration;
    });
  }
}
